import { ref } from "vue";

export const useRef = () => {
  const _ref = ref(null);
  return _ref;
}